export default __webpack_public_path__ + "static/media/au.5b98a120.svg";